import React from 'react';
import fetch from 'unfetch';
import { func, string, number, oneOfType } from 'prop-types';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import Icon from 'components/icon';

export default class QueryForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            QueryNotes: '',
            errorMessage: '',
            dataMessage: '',
            dataSuccess: ''
        };

        this.handleTextareaChange = this.handleTextareaChange.bind(this);
    }

    sendQueryForm() {
        const queryFormLength = Object.entries(this.state).filter(item => item[0].includes('Query') && item[1]).length;
        if ((!this.state.QueryNotes) || (queryFormLength <= 1)) {
            this.setState({ errorMessage: 'please select a reason for your query and add a comment' });
            return;
        }
        this.setState({ errorMessage: '' });
        const dataObj = {
            method: 'POST',
            headers: {
                Authorization: this.props.bearerToken,
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                refId: this.props.refID,
                DraftDocketGUID: this.props.DraftDocketGuid,
                ActionType: 'Query',
                DraftDocketClientType: this.props.DraftDocketClientType,
                QueryHours: this.state.QueryHours,
                QueryLoads: this.state.QueryLoads,
                QueryPONumber: this.state.QueryPONumber,
                QueryWaitingTime: this.state.QueryWaitingTime,
                QueryOther: this.state.QueryOther,
                QueryNotes: this.state.QueryNotes
            })
        };
        postData(`${this.props.dataURL}/api/DraftDocketAction`)
            .then(data => {
                this.setState({ dataMessage: data.Message, dataSuccess: data.Success });
                this.props.updateQueryResult(data.Message, data.Success);
            });

        function postData(dataUrl = '') {
            return fetch(dataUrl, dataObj)
                .then(response => response.json());
        }
    }

    handleChange(e) {
        e.target.classList.toggle('active');
        this.setState({ [e.target.id]: e.target.checked });
    }

    handleTextareaChange(e) {
        e.preventDefault();
        this.setState({ QueryNotes: e.target.value });
    }

    render() {
        if (this.state.dataMessage) {
            return (
                <div className="fl-query-form">
                    <div className={this.state.dataSuccess ? 'success' : 'error data-error'}>
                        {this.state.dataSuccess && <h1>Thanks for your query</h1>}
                        {this.state.dataMessage}
                    </div>
                    <div className="submit-form">
                        <button
                            className="btn-skin-2"
                            onClick={() => this.props.toggleQueryForm(true)}
                        >
                            Close
                        </button>
                    </div>
                </div>
            );
        }
        return (
            <div className="fl-query-form">
                <ReactCSSTransitionGroup
                    component="div"
                    className="active-filters"
                    transitionName="slide-up-down"
                    transitionEnterTimeout={200}
                    transitionLeaveTimeout={0}
                >
                    <h3>reason for query</h3>
                    {this.state.errorMessage && <h3 className="error">{this.state.errorMessage}</h3>}
                    <div className="form-choices">
                        <div className="form-element">
                            <div className="input-wrapper">
                                <label htmlFor="QueryHours">Incorrect Hours</label>
                                <input
                                    id="QueryHours"
                                    onChange={e => this.handleChange(e)}
                                    onKeyPress={e => this.handleChange(e)}
                                    type="checkbox"
                                />
                                <Icon glyph="tick" />
                            </div>
                        </div>
                        <div className="form-element">
                            <div className="input-wrapper">
                                <label htmlFor="QueryLoads">Incorrect Loads</label>
                                <input
                                    id="QueryLoads"
                                    onChange={e => this.handleChange(e)}
                                    onKeyPress={e => this.handleChange(e)}
                                    type="checkbox"
                                />
                                <Icon glyph="tick" />
                            </div>
                        </div>
                        <div className="form-element">
                            <div className="input-wrapper">
                                <label htmlFor="QueryPONumber">Incorrect P/0#</label>
                                <input
                                    id="QueryPONumber"
                                    onChange={e => this.handleChange(e)}
                                    onKeyPress={e => this.handleChange(e)}
                                    type="checkbox"
                                />
                                <Icon glyph="tick" />
                            </div>
                        </div>
                        <div className="form-element">
                            <div className="input-wrapper">
                                <label htmlFor="QueryWaitingTime">Waiting Time</label>
                                <input
                                    id="QueryWaitingTime"
                                    onChange={e => this.handleChange(e)}
                                    onKeyPress={e => this.handleChange(e)}
                                    type="checkbox"
                                />
                                <Icon glyph="tick" />
                            </div>
                        </div>
                        <div className="form-element">
                            <div className="input-wrapper">
                                <label htmlFor="QueryOther">Other Reason</label>
                                <input
                                    id="QueryOther"
                                    onChange={e => this.handleChange(e)}
                                    onKeyPress={e => this.handleChange(e)}
                                    type="checkbox"
                                />
                                <Icon glyph="tick" />
                            </div>
                        </div>
                    </div>
                    <div className="form-element comment">
                        <div className="input-wrapper">
                            <textarea
                                rows="3"
                                placeholder="Enter Message (required)"
                                value={this.state.QueryNotes}
                                onChange={this.handleTextareaChange}
                                className={(this.state.errorMessage && !this.state.QueryNotes) ? 'error-input' : ''}
                            />
                        </div>
                    </div>
                    <div className="submit-form">
                        <button
                            className="btn-skin-2"
                            onClick={() => this.props.toggleQueryForm()}
                        >
                        Cancel
                        </button>
                        <button
                            className="btn-skin-1"
                            onClick={() => this.sendQueryForm()}
                        >
                        Send Query
                        </button>
                    </div>
                </ReactCSSTransitionGroup>
            </div>
        );
    }
}

QueryForm.propTypes = {
    toggleQueryForm: func.isRequired,
    refID: oneOfType([string, number]).isRequired,
    DraftDocketGuid: string.isRequired,
    DraftDocketClientType: string.isRequired,
    bearerToken: string.isRequired,
    dataURL: string.isRequired,
    updateQueryResult: func.isRequired
};
